import React, { useEffect, useMemo } from 'react';
import { Form, Typography, Button, Card, Divider, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import CommonForm from '../../../global/form';
import { useGenericMutation } from '../../../../queries/use-generic-mutation';
import SOURCES from '../../../../utils/constants';
import { cn } from '../../../../utils/cn';
import Spinner from '../../../global/spinner';

const { Title, Text } = Typography;

const EnhancedNurturePro = ({ destinations, activeDestination, btnClassName }) => {
    const [form] = Form.useForm();
    const DESTINATION_NURTUREPRO = SOURCES.DESTINATION_NURTUREPRO || "nurturepro";

    const { mutate: saveNurturePro, isPending: isSaving } = useGenericMutation({
        endpoint: "integration",
        method: "POST",
        onSuccess: () => message.success("NurturePro configuration saved successfully")
    });

    useEffect(() => {
        if (destinations) {
            const config = destinations.find(d => d.integrationCompany === DESTINATION_NURTUREPRO);
            if (config) {
                form.setFieldsValue({
                    apiKey: config.secretKey,
                    sendLeadsLimit: config.leadSentConfig?.sentLimit || 0
                });
            }
        }
    }, [destinations, form]);

    const onFinish = (values) => {
        saveNurturePro({
            secretKey: values.apiKey,
            sendLeadsLimit: values.sendLeadsLimit,
            integrationCompany: DESTINATION_NURTUREPRO,
        });
    };

    const formData = useMemo(() => [
        {
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            label: "API Key",
            name: "apiKey",
            placeholder: "Enter NurturePro API Key",
            required: true,
            span: 24,
        },
        {
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            label: "Initial Lead Send Limit",
            name: "sendLeadsLimit",
            placeholder: "Leads limit",
            type: "number",
            span: 24,
        }
    ], []);

    return (
        <div className="animate-in fade-in duration-500">
            <div className="flex items-center gap-4 mb-8">
                <div className="size-16 rounded-2xl bg-white shadow-sm border border-gray-100 flex items-center justify-center p-3">
                    <img src={activeDestination.icon} alt={activeDestination.title} className="w-full h-full object-contain" />
                </div>
                <div>
                    <Title level={3} className="!mb-1">{activeDestination.title} Configuration</Title>
                    <Text type="secondary">Connect your NurturePro account and sync leads.</Text>
                </div>
            </div>

            <Card className="rounded-2xl border-none shadow-sm">
                <CommonForm
                    form={form}
                    data={formData}
                    onFinish={onFinish}
                    layoutType="vertical"
                />
                <Divider className="mb-4 border-gray-100" />
                <div className="flex justify-start">
                    <Button
                        size="large"
                        icon={isSaving ? null : <SaveOutlined />}
                        onClick={() => form.submit()}
                        className={cn(btnClassName)}
                    >
                        {isSaving && <Spinner className={"!border-white"} />}
                        Save Configuration
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default EnhancedNurturePro;
